<template>
  <div class="status-text" :class="`status${status}`">
    {{ text }}
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'StatusText',
  props: ['text', 'status'],
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
@media only screen and (min-width: 756px) {
  .status-text {
    width: 98px;
    height: 34px;
    line-height: 14px;
    display: block;
    margin: 0 auto;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.status1 {
      background: url('../../assets/img/bzt.png');
    }

    &.status2 {
      background: url('../../assets/img/gzt.png');
    }

    &.status3 {
      background: url('../../assets/img/rzt.png');
    }

    &.status0 {
      background: url('../../assets/img/rzt.png');
    }
  }
}

@media only screen and (max-width: 755px) {
  .status-text {
    width: 98px;
    height: 34px;
    line-height: 14px;
    display: block;
    margin: 0 auto;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.status1 {
      background: url('../../assets/img/bzt.png');
    }

    &.status2 {
      background: url('../../assets/img/gzt.png');
    }

    &.status3 {
      background: url('../../assets/img/rzt.png');
    }

    &.status0 {
      background: url('../../assets/img/rzt.png');
    }
  }
}
</style>
